/** Coincide con backend: rol de portal de inversionista. */
export function isInvestorRoleName(name: string | undefined | null): boolean {
  if (!name) return false;
  const n = name.trim().toLowerCase();
  return n === 'inversor' || n === 'inversionista';
}

/** Coincide con backend: rol de portal de inquilino. */
export function isTenantRoleName(name: string | undefined | null): boolean {
  if (!name) return false;
  const n = name.trim().toLowerCase();
  return n === 'inquilino' || n === 'tenant';
}

/** Rol dedicado a reportes de mantenimiento (navegación y rutas restringidas). */
export function isMaintenanceRoleName(name: string | undefined | null): boolean {
  if (!name) return false;
  return name.trim().toLowerCase() === 'mantenimiento';
}
